var createUrlWithCountryPrefix = function createUrlWithCountryPrefix(_ref) {
  var url = _ref.url,
    countryPrefix = _ref.countryPrefix;
  return "".concat(countryPrefix ? "/".concat(countryPrefix) : '').concat(url);
};
export default createUrlWithCountryPrefix;